import React from "react";

function ProjectCards({ project }) {
  let color;
  if (project.projectName === "Frontend Project") {
    color = "#E07DAB";
  } else if (project.projectName === "Full Stack Project") {
    color = "#53BBC8";
  } else if (project.projectName === "Application Project") {
    color = "#939BAE";
  } else if (project.projectName === "IOT Project") {
    color = "#E98E61";
  } else {
    color = "#CD793A";
  }

  return (
    <div
      className="relative overflow-hidden rounded-3xl shadow-xl shadow-slate-950/40 hover:-translate-y-1 transition-all duration-200"
      data-aos="fade-up"
      style={{ backgroundColor: color }}
    >
      <div className="flex items-center justify-between gap-3 lg:gap-6 p-4 sm:p-5 lg:p-7">
        <div className="flex flex-col justify-center">
          <h3 className="text-[17px] sm:text-[19px] lg:text-[24px] text-white font-bold">
            {project.projectName}
          </h3>
          <button className="mt-4 inline-flex items-center justify-center rounded-full bg-slate-950/80 px-3 sm:px-4 lg:px-5 py-2 text-xs sm:text-sm font-semibold text-white hover:bg-slate-900 shadow-lg shadow-slate-950/60 transition-all duration-200">
            Join With Us
          </button>
        </div>
        <img
          src={project.projectImage}
          alt={project.projectName}
          className="w-[7rem] sm:w-[9rem] lg:w-[11rem] object-contain"
        />
      </div>
    </div>
  );
}

export default ProjectCards;
